import React from "react";
import {
  LuLayoutDashboard,
  LuStore,
  LuClipboardList,
  LuShoppingCart,
  LuPackage,
  LuUsers,
  LuBadgePercent,
  LuLifeBuoy,
  LuSettings,
  LuLogOut,
} from "react-icons/lu";

import { BlockMenu } from "./blockMenu";
//Api
//import { logOut } from "../../../api/login";
//Styles
import "./style.css";
//import { IconIA } from "../../../../api/ia";

export const AdminMenu = ({ menuOpen }) => {
  const blockMenu1 = [
    {
      id: 101,
      name: "Inicio",
      icon: <LuLayoutDashboard />,
      component: "dashboard",
    },
    {
      id: 102,
      name: "Canal de venta",
      icon: <LuStore />,
      component: "salesChannel",
    },
    {
      id: 103,
      name: "Pedidos",
      icon: <LuClipboardList />,
      component: "orders",
    },
    {
      id: 105,
      name: "Carritos",
      icon: <LuShoppingCart />,
      component: "carts",
    },
    {
      id: 104,
      name: "Productos",
      icon: <LuPackage />,
      component: "products",
      childs: [
        {
          id: 1000,
          name: "Productos",
          component: "products",
          fatherComponent: "products",
        },
        {
          id: 1002,
          name: "Catálogos",
          component: "catalogs",
          fatherComponent: "products",
        },
        {
          id: 1001,
          name: "Categorías",
          component: "categories",
          fatherComponent: "products",
        },
        {
          id: 1003,
          name: "Atributos",
          component: "attributes",
          fatherComponent: "products",
        },
      ],
    },
    {
      id: 201,
      name: "Clientes",
      icon: <LuUsers />,
      component: "clients",
    },
    {
      id: 202,
      name: "Descuentos",
      icon: <LuBadgePercent />,
      component: "discounts",
    },
  ];

  const blockMenu2 = [
    /* { id: 201, name: "Clientes", icon: <LuUsers />, component: "clients" },
    { id: 202, name: "Descuentos", icon: <LuBadgePercent />, component: "discounts" },*/
  ];

  /*{ id: 301, name: "Ayuda", icon: <IoHelpCircleOutline />, component: "" },*/
  const blockMenu3 = [
    { id: 301, name: "Ayuda", icon: <LuLifeBuoy />, component: "help" },
    /*{ id: 301, name: "Asistente IA", icon: IconIA, component: "asistente" },*/
    {
      id: 302,
      name: "Configuración",
      icon: <LuSettings />,
      component: "configuration",
    },
    {
      id: 303,
      name: "Cerrar sesión",
      icon: <LuLogOut color={"var(--color-error)"} />,
      component: "logout",
    },
  ];

  return (
    <div
      className={
        menuOpen ? "adminSidebarMenuOpen adminSidebarMenu" : "adminSidebarMenu"
      }
    >
      <div className={menuOpen ? "menuTitleBlockOpen" : "menuTitleBlock"}>
        <div
          className={
            menuOpen ? "menuSeparator menuSeparatorOpen" : "menuSeparator"
          }
        ></div>
        <div className="menuTitle">MENÚ</div>
      </div>
      <BlockMenu block={blockMenu1} menuOpen={menuOpen} />

      {blockMenu2.length > 0 && (
        <>
          <div
            className={menuOpen ? "menuTitleBlockOpen" : "menuTitleBlock"}
            style={{ paddingTop: "10px" }}
          >
            <div
              className={
                menuOpen ? "menuSeparator menuSeparatorOpen" : "menuSeparator"
              }
            ></div>
            <div className="menuTitle" style={{ marginTop: "15px" }}>
              MAS
            </div>
          </div>
          <BlockMenu block={blockMenu2} menuOpen={menuOpen} />
        </>
      )}

      <div className="menuBottom">
        <BlockMenu block={blockMenu3} menuOpen={menuOpen} />
      </div>
    </div>
  );
};
